import { Flex, Image, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Modal from "src/components/Modal";
import { H3, BodyText2 } from "src/atoms/typography";
import getImageSrc from "src/utils/getImageSrc";

function StopMonitoringDialog({ isOpen, onDismiss, onOk }) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen}>
      <Flex
        width="280px"
        pt="24px"
        pb="8px"
        px="32px"
        flexDirection="column"
        alignItems="center"
      >
        <Image src={getImageSrc("monitoring-stopped.svg")} />
        <H3 mt="16px" color="highEmphasis" textAlign="center">
          {t("babyStation.stopMonitoringDialog.heading")}
        </H3>
        <BodyText2 mt="8px" color="mediumEmphasis" textAlign="center">
          {t("babyStation.stopMonitoringDialog.text")}
        </BodyText2>

        <Flex
          width="100%"
          mt="16px"
          pr="8px"
          pb="8px"
          justifyContent="space-between"
        >
          <Button
            variant="flatPrimary"
            onClick={onDismiss}
            minWidth="80px"
            mr="8px"
          >
            {t("buttons.cancel")}
          </Button>
          <Button variant="flatPrimary" onClick={onOk} minWidth="80px">
            {t("buttons.stop")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default StopMonitoringDialog;
